<template>
  <div
    class="letterGuarantee"
    ref="letterGuarantee"
  >
    <a
      type="primary"
      @click="showModal"
    >
      {{ pswTitle }}
    </a>
    <a-modal
      class="letter-content"
      wrap-class-name="webS"
      :title="pswTitle"
      :visible="visible"
      :confirm-loading="confirmLoading"
      @ok="handleOk"
      @cancel="handleCancel"
      cancel-text="取消"
      ok-text="确定"
      :get-container="()=>$refs.letterGuarantee"
      width="800px"
      style="background: red;"
    >
      <!-- 密码 -->
      <a-spin
        :spinning="spinPassword"
      >
        <!-- <div class="letter-center">
          <h3>企业信息</h3>
          <div
            style="display: flex;
            align-items: center;
            margin-bottom: 20px;
            position: relative;
            "
          >
            <span
              style="width: 264px;
              text-align: right;
              margin-right: 14px;"
            >企业名称：</span><a-input-password
              v-model="oldPwd"
              placeholder="请输入原始密码"
              style="width: 330px;
              background: #FFFFFF;
              border-radius: 3px;"
            />
          </div>
          <div
            style="display: flex;
            align-items: center;
            margin-bottom: 20px;
            position: relative;"
          >
            <span
              style="width: 264px;
              text-align: right;
              margin-right: 14px;"
            >企业社会统一信用代码：</span><a-input-password
              v-model="newPwd"
              placeholder="8至16位字符，至少1位数字和1字母组合"
              style="width: 330px;
              background: #FFFFFF;
              border-radius: 3px;"
            />
          </div>
          <div
            style="display: flex;
            align-items: center;
            margin-bottom: 20px;
            position: relative;"
          >
            <span
              style="width: 264px;
              text-align: right;
              margin-right: 14px;"
            >* 经办人姓名：</span><a-input-password
              v-model="conNewPwd"
              placeholder="再次输入新密码"
              style="width: 330px;
              background: #FFFFFF;
              border-radius: 3px;"
            />
          </div>
          <div
            style="display: flex;
            align-items: center;
            margin-bottom: 20px;
            position: relative;"
          >
            <span
              style="width: 264px;
              text-align: right;
              margin-right: 14px;"
            ><i style="color:red;padding-right:8px">*</i>经办人手机号：</span><a-input-password
              v-model="conNewPwd"
              placeholder="再次输入新密码"
              style="width: 330px;
              background: #FFFFFF;
              border-radius: 3px;"
            />
          </div>
        </div> -->
        <div class="right-con">
          <a-form-model
            ref="form2"
            :model="letterData"
            :rules="rule1"
            :label-col="{ xs: { span: 24 }, sm: { span: 8 } }"
            :wrapper-col="{ xs: { span: 24 }, sm: { span: 12 } }"
          >
            <!-- 采招信息/采招公司按要求隐藏，默认固定为 陕西省采购招标有限责任公司（见 setDefaultProcurementCompany）
          <h3>采招信息</h3>
          <a-form-model-item label="采招公司" >
            <a-input v-model="$store.state.info.procurementCompany"  />
            <el-select
                v-model="letterData.procurementCompany"
                placeholder="请选择"
                style="width: 376px!important;"
                class="periodSelect"
                @change="changeProcurementCompany"
              >
              <el-option
                v-for="item in CompanyItem"
                  :key="item.value"
                  :value="item.value"
                  :label="item.label"
                ></el-option>
              </el-select>

          </a-form-model-item>
          -->
            <h3>企业信息</h3>
            <a-form-model-item label="企业名称">
              <a-input
                v-model="$store.state.info.companyName"
                disabled
              />
            </a-form-model-item>
            <a-form-model-item label="企业社会统一信用代码">
              <a-input
                v-model="$store.state.info.creditCode"
                disabled
              />
            </a-form-model-item>

            <a-form-model-item
              label="经办人姓名"
              prop="responsiblePersonName"
            >
              <a-input v-model="letterData.responsiblePersonName" />
            </a-form-model-item>
            <a-form-model-item
              label="经办人手机号码"
              prop="responsiblePersonPhone"
            >
              <a-input v-model="letterData.responsiblePersonPhone" />
            </a-form-model-item>
            <h3>项目信息</h3>
            <a-form-model-item
              label="项目名称"
              prop="projectName"
            >
              <a-input v-model="letterData.projectName" />
            </a-form-model-item>
            <a-form-model-item
              label="标段名称"
              prop="sectionName"
            >
              <a-input v-model="letterData.sectionName" />
            </a-form-model-item>
            <a-form-model-item
              label="项目编号"
              prop="projectCode"
            >
              <a-input v-model="letterData.projectCode" />
            </a-form-model-item>
            <a-form-model-item
              label="标段编号"
              prop="sectionCode"
            >
              <a-input v-model="letterData.sectionCode" />
            </a-form-model-item>
            <a-form-model-item
              label="保额（元）"
              prop="sumAmount"
            >
              <a-input
                type="number"
                v-model="letterData.sumAmount"
              />
            </a-form-model-item>
            <a-form-model-item
              label="招标人名称（受益人）"
              prop="tendereeName"
            >
              <a-input v-model="letterData.tendereeName" />
            </a-form-model-item>
            <a-form-model-item label="招标人（受益人）统一社会信用代码">
              <a-input v-model="letterData.tendereeCreditCode" />
            </a-form-model-item>
            <a-form-model-item
              label="担保期限（天）"
              prop="period"
            >
              <!-- <a-input type="number" v-model="letterData.period" /> -->
              <el-select
                v-model="letterData.period"
                placeholder="请选择"
                style="width: 376px!important;"
                class="periodSelect"
              >
                <el-option
                  v-for="item in [90,120,150]"
                  :key="item"
                  :value="item"
                  :label="item"
                />
              </el-select>
            </a-form-model-item>
            <a-form-model-item
              label="开标日期"
              prop="bidOpenDate"
            >
              <!-- <a-input v-model="letterData.bidOpenDate" /> -->
              <a-date-picker
                :locale="locale"
                style="width: 376px!important;"
                v-model="letterData.bidOpenDate"
                format="YYYY-MM-DD"
              />
            </a-form-model-item>
          </a-form-model>
        </div>
      </a-spin>
    </a-modal>
  </div>
</template>

<script>
import locale from 'ant-design-vue/es/date-picker/locale/zh_CN';
import moment from 'moment';
import 'moment/locale/zh-cn';
import { postApplyInsureApplyInfo, getProcurementCompany } from './api.js';

// 采招公司下拉已隐藏，固定默认 陕西省采购招标有限责任公司
const DEFAULT_COMPANY_LABEL = '陕西省采购招标有限责任公司';
// 字典缺失/加载失败时的兜底 value（后端 TenderFillModel 约定：陕西省采购招标有限责任公司=1）
const DEFAULT_COMPANY_VALUE = '1';
export default {
  name: 'LetterGuaranteeNumber',
  props: {
    pswType: {
      type: String,
      default: '1',
    },
    visible: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      moment,
      locale,
      pswTitle: '申请保函',
      oldPwd: '',
      newPwd: '',
      conNewPwd: '',
      confirmLoading: false, // 按钮加载
      spinPassword: false, // 加载
      letterData: {
        responsiblePersonName: '',
        responsiblePersonPhone: '',
        projectName: '',
        sectionName: '',
        projectCode: '',
        sectionCode: '',
        sumAmount: '',
        tendereeName: '',
        tendereeCreditCode: '',
        period: 120,
        bidOpenDate: '',
        procurementCompany: '',
      },
      CompanyItem: [],
      rule1: {
        responsiblePersonName: [{ required: true, message: '请输入经办人姓名', trigger: 'blur' }],
        responsiblePersonPhone: [{ required: true, message: '请输入经办人手机号码', trigger: 'blur' }],
        projectName: [{ required: true, message: '请输入项目名称', trigger: 'blur' }],
        // sectionName: [{ required: true, message: '请输入标段名称', trigger: 'blur' }],
        projectCode: [{ required: true, message: '请输入项目编号', trigger: 'blur' }],
        // sectionCode: [{ required: true, message: '请输入标段编号', trigger: 'blur' }],
        sumAmount: [{ required: true, message: '请输入保额', trigger: 'blur' }],
        tendereeName: [{ required: true, message: '请输入招标人名称', trigger: 'blur' }],
        period: [{ required: true, message: '请输入 担保期限', trigger: 'blur' }],
        bidOpenDate: [{ required: true, message: '请输入开标日期', trigger: 'blur' }],

      },
    };
  },
  watch: {
    visible(val) {
      if (val === true) {
        console.log(this.$store.state);
        if (this.letterData.responsiblePersonPhone === '') {
          this.letterData.responsiblePersonPhone = JSON.parse(sessionStorage.getItem('telephone'));
        }
        // 采招公司下拉已隐藏，每次打开兜底一次默认值
        if (!this.letterData.procurementCompany) {
          this.setDefaultProcurementCompany();
        }
      }
    },
  },
  mounted() {
    if (this.pswType === '1') {
      this.pswTitle = '申请保函';
    } else {
      this.pswTitle = '申请保函';
    }
    getProcurementCompany().then(res => {
      if (res.status === 200 && res.data && res.data.data) {
        this.CompanyItem = res.data.data;
      }
      this.setDefaultProcurementCompany();
    }, () => {
      this.setDefaultProcurementCompany();
    });
  },
  methods: {
    showModal() {
      this.visible = true;
    },
    // 采招公司默认 陕西省采购招标有限责任公司：value 取字典项（落库的是字典值，不是名称），
    // 字典缺失时兜底 '1'。
    // 注意：不再联动「招标人名称（受益人）」，该字段默认留空、由用户自行填写
    setDefaultProcurementCompany() {
      const target = this.CompanyItem.find(item => item.label === DEFAULT_COMPANY_LABEL);
      this.letterData.procurementCompany = target ? target.value : DEFAULT_COMPANY_VALUE;
    },
    handleOk() {
      const that = this;
      this.$refs.form2.validate(valid => {
        if (valid) {
          const params = this.letterData;
          params.bidOpenDate = moment(this.letterData.bidOpenDate).format('YYYY-MM-DD');
          console.log(params);
          // check({ ...this.applicantInform }).then(res => {
          //   if (res.data.status === 500) {
          //     this.$notification.error({ message: res.data.message });
          //   } else {
          //     this.form = res.data.data;
          //     this.isOpen = 2;
          //   }
          // });
          postApplyInsureApplyInfo(params).then(res => {
            if (res.data.status === 200) {
              that.visible = false;
              that.$message.success('提交成功！');
              that.letterData = {
                responsiblePersonName: '',
                responsiblePersonPhone: '',
                projectName: '',
                sectionName: '',
                projectCode: '',
                sectionCode: '',
                sumAmount: '',
                tendereeName: '',
                tendereeCreditCode: '',
                period: '',
                bidOpenDate: '',
              };
              window.open(res.data.data.redirecturl, '_blank');
            }
          });
        }
      });

      // this.spinPassword = true;
      // this.confirmLoading = true;
      // if (this.pswType === '1') {
      //   modifyPassword({ pwdOld: this.oldPwd, pwdNew: this.newPwd, pwdConfirm: this.conNewPwd }).then(res => {
      //     if (res.data.status === 'SUCCESS') {
      //       this.visible = false;
      //       this.spinPassword = false;
      //       this.confirmLoading = false;
      //       this.$message.success('申请保函成功！');
      //       this.$parent.$parent.info();
      //     } else {
      //       this.spinPassword = false;
      //       this.confirmLoading = false;
      //       this.$message.warning(res.data.errorMsg);
      //     }
      //   });
      // } else {
      //   setPassword({ pwdNew: this.newPwd, pwdConfirm: this.conNewPwd }).then(res => {
      //     if (res.data.status === 'SUCCESS') {
      //       this.visible = false;
      //       this.spinPassword = false;
      //       this.confirmLoading = false;
      //       this.$message.success('设置密码成功！');
      //       this.$parent.$parent.info();
      //     } else {
      //       this.spinPassword = false;
      //       this.confirmLoading = false;
      //       this.$message.warning(res.data.errorMsg);
      //     }
      //   });
      // }

    },
    handleCancel() {
      this.visible = false;
    },
    changeProcurementCompany(value) {
      const selectedItem = this.CompanyItem.find(item => item.value === value);
      if (selectedItem.label === '陕西省采购招标有限责任公司') {
        this.letterData.tendereeName = selectedItem.label;
      } else {
        this.letterData.tendereeName = '';

      }
    },
  },
};
</script>

<style lang="less" scoped>
.letterGuarantee {
  /deep/ .ant-modal-header {
    border: none;
  }
  /deep/ .ant-modal-footer {
    border: none;
    height: 76px;
  }
  /deep/ .ant-form-item {
    margin-bottom: 10px;
  }
  /deep/ .ant-calendar-picker-input{
    width: 376px;
  }
  /deep/ .ant-form-item-control{
    line-height: 20px;
  }
  /deep/  .ant-input[disabled]{
    color: #000;
  }
  /deep/ .ant-modal-body {
    padding: 0 24px;
  }
  /deep/ .ant-spin-container {
    padding-top: 40px;
    border-top: 1px solid #EBF2F7;
  }
  /deep/ .ant-btn {
    width: 100px;
    height: 36px;
    border-radius: 3px;
    border: 1px solid #0E52D4;
    font-size: 14px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    margin-top: 10px;
    color: #0E52D4;
  }
  /deep/ .ant-btn-primary {
    background: #0E52D4;
    color: #fff;
    margin-right: 14px;
    margin-left: 20px;
  }
}
.letterGuarantee h3{
  text-align: left;
  font-family: PingFang SC, PingFang SC;
  font-weight: 500;
  font-size: 22px;
  color: #333333;
  line-height: 28px;
  text-align: left;
  font-style: normal;
  text-transform: none;
}
a{
    color:  #0E52D4;
  }

.ant-modal{
  width: 900px;

}
.ant-modal-content{
  background: red;
  background: url("~@/assets/image/letter-bg.png") no-repeat!important;

}
.flex1 {
  width: 120px;
  display: flex;
  flex-direction: row-reverse;
}
</style>
<style>

</style>
